import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteConnection, GetAllConnections } from '../../store/actions/new/connectionAction';
import { ShimmerCategoryItem } from 'react-shimmer-effects';
import SearchForm from '../default/search/searchForm';
import AddNewConnectionPopup from './popup/addNewCCPopup';
import NoContentFound from '../default/not-found/notFound';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { ADD_CONNECTION_ITEM } from '../../store/constants/connectionConstants';
import ShimmerImage from '../default/popup/shimmerImage/shimmerImage';
import { InitialAvatar } from '../default/utils/defaultAvatar';

const ConnectionList = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const prevSearchTermRef = useRef();
    const [openPopup, setPopup] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [canShare, setCanShare] = useState(true);
    const handlePopup = () => {
        setPopup(true);
    }
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.list-edit-dropdown') && 
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
         }
    };
    const allData = useSelector((state) => state.connectionAllData);
    const { connectionData, isLoading } = allData;
    const { data, pagination } = connectionData;

    const dispatch = useDispatch();
    // List share feature
    const handleShareCard = async (e, shareLink) => {
        e.preventDefault();
        try {
            if (navigator.share) {
                // Mobile sharing
                await navigator.share({
                    title: document.title,
                    url: shareLink
                });
                console.log('Thanks for sharing!');
            } else {
                // Desktop sharing - copy to clipboard
                await navigator.clipboard.writeText(shareLink);
                // You might want to show a toast or alert here
                alert('Link copied to clipboard!');
            }
        } catch (error) {
            console.error('Error sharing:', error);
        }
    };
    useEffect(() => {
        if (!hasLoaded) {
            // Check if store already has data
            if (!connectionData || !connectionData.data || connectionData.data.length === 0) {
                let postData = {
                    page   : 1,
                    keyword: searchTerm
                }
                dispatch(GetAllConnections(postData));
            }
            setHasLoaded(true);
        }
        if (prevSearchTermRef.current !== searchTerm) {
            searchConnection();
        }
        prevSearchTermRef.current = searchTerm;

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
        setCanShare(navigator.share ? true : false);

    }, [dispatch, data, searchTerm])
    // Search Connection
    const searchConnection = async () => {
        if(!hasLoaded) return;
        setLoading(true);
        let postData = {
            page   : 1,
            keyword: searchTerm
        }
        await dispatch(GetAllConnections(postData));
        setLoading(false);
    }
    // Load more connection
    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page   : nextPage,
                keyword: searchTerm
            }
            dispatch(GetAllConnections(postData));
        }
    };
    
    // Add connection item
    const AddConnectionItem = (itemRes) => {
        if (itemRes.status >= 200 ){
            dispatch({
                type: ADD_CONNECTION_ITEM,
                payload: {
                    data: itemRes.data
                }
            });
        }
    }
    //remove connection item
     const MySwal = withReactContent(Swal)
     const handleDeleteConnection = (id) => {
         MySwal.fire({
             title: "Are you sure?",
             text: "You won't be able to revert this!",
             icon: "warning",
             showCancelButton: true,
             confirmButtonColor: "#d33",
             cancelButtonColor: "#ccc",
             confirmButtonText: "Conform",
             didOpen: () => {
                 document.body.style.overflow = "hidden"; 
               },
               willClose: () => {
                 document.body.style.overflow = ""; 
               }
         }).then((result) => {
             if (result.isConfirmed) {
                dispatch(deleteConnection(id));
               
             }
         });
 
     }
    return (
        <div className="card-container card-list-area">
            <div className="connection-header">
                <h3>Connections</h3>
                <div className="filter-wrapper">
                    <SearchForm
                        placeholder='Search card...'
                        loading={loading}
                        onChange={async (val) => {
                            setSearchTerm(val);
                        }}

                    />
                    <div className="list-filter">
                        <i className="ri-equalizer-line"></i>
                        <span>Filter</span>
                    </div>
                    <div className="list-filter add-new-btn" onClick={handlePopup}>
                        <i className="ri-add-line"></i>
                        <span>Add New</span>
                    </div>
                </div>
            </div>
            <div className="list-table connection-list">
                {Array.isArray(data) && data.length > 0 && (
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Job title</th>
                                <th>Company</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="list-profile">
                                            {item.preview_photo ? (
                                                <ShimmerImage
                                                    src={item.preview_photo}
                                                    alt={item.card_name}
                                                    width={65}
                                                />
                                            ) : (
                                                <InitialAvatar 
                                                    title={`${item.card_name}`}
                                                    size={65}
                                                />
                                            )}
                                            <span>{item.card_name}</span>
                                        </div>
                                    </td>
                                    <td>{item.card_title}</td>
                                    <td>{item.card_company}</td>
                                    <td align='right'>
                                        <Link className="card-btn list-btn" target='_blank' to={item.card_link}>
                                            <i className="ri-eye-line"></i> View
                                        </Link>
                                        {canShare && (
                                        <Link className="icon-button list-btn" target='_blank' onClick={(e) => {handleShareCard(e, item.shareLink)}}>
                                            <i className="ri-share-2-line"></i>
                                        </Link>
                                        )}
                                        <button 
                                            className="share-button icon-button list-btn dropdown-toggle-btn"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleDropdown(index);
                                            }}
                                        >
                                            <i
                                                className="ri-more-2-fill"
                                            ></i>
                                        </button>
                                        <div className="list-edit-dropdown">
                                            {openDropdown === index && (
                                                <ul>
                                                    <li><Link onClick={() =>{
                                                        handleDeleteConnection(item.connectID);
                                                        setOpenDropdown(null);
                                                    }}>Delete</Link></li>
                                                </ul>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                {!isLoading && !data &&
                    <NoContentFound title="No connection found!" />
                }
                {isLoading &&
                    <>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                    </>
                }
                {!isLoading && data && pagination.page_last > pagination.page && (
                    <div className="load-more-container">
                        <button
                            className="load-more-btn"
                            onClick={loadMore}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Loading...' : 'Load More'}
                        </button>
                    </div>
                )}
            </div>

            <AddNewConnectionPopup openModal={openPopup} setOpen={setPopup} type="connection" onSubmitResponse={AddConnectionItem}/>
        </div>
    );
}

export default ConnectionList;
